<template>
    <div class="pt-6">
        <dt class="text-lg" v-if="section.title">
            <!-- Expand/collapse question button -->
            <button
                @click="accordion"
                type="button"
                class="text-left w-full flex justify-between items-start text-gray-400"
                :class="[section.noPoint ? 'cursor-default' : 'cursor-pointer']"
                aria-controls="faq-0"
                aria-expanded="false"
            >
                <span class="font-medium text-gray-900">{{ paragraf }} {{ section.title }}</span>
                <span v-if="!section.noPoint" class="ml-6 h-7 flex items-center">
                    <ChevronDownIcon
                        class="h-6 w-6 transition-transform flex-shrink-0"
                        :class="[isOpen ? 'rotate-180' : 'rotate-0']"
                    />
                </span>
            </button>
        </dt>
        <dd v-if="isOpen" class="sm:pr-12" :class="[section.title ? 'mt-4' : '']">
            <ul v-if="section.noPoint" class="text-base text-gray-500">
                <li v-for="(point, index) in section.points" :key="index">
                    <p v-if="point" v-html="point"></p>
                </li>
            </ul>
            <ol v-else class="text-base text-gray-500 list-decimal">
                <li v-for="(point, index) in section.points.filter(Boolean)" :key="index">
                    <p v-if="point.length && !Array.isArray(point)" v-html="point"></p>
                    <template v-if="point.length && Array.isArray(point)">
                        {{ point[0] }}
                        <ol class="text-base text-gray-500">
                            <li
                                v-for="(subpoint, subindex) in point[1].filter(String)"
                                :key="subindex"
                            >
                                <p v-html="subpoint" :style="{ 'word-break': 'break-word' }"></p>
                            </li>
                        </ol>
                        <p v-if="point[2]">{{ point[2] }}</p>
                    </template>
                </li>
            </ol>
        </dd>
    </div>
</template>

<script>
import { ChevronDownIcon } from "@easy/ui/icons";

export default {
    name: "TermsSection",
    components: {
        ChevronDownIcon,
    },
    props: {
        section: Object,
        index: Number,
        view: String,
    },
    data() {
        return {
            isOpen: true,
        };
    },
    computed: {
        paragraf() {
            return this.section.noPoint || this.view == "policy" ? "" : `§ ${this.index + 1}. `;
        },
    },
    emits: ["updateIframeHeight"],
    methods: {
        accordion() {
            this.isOpen = !this.isOpen;
            this.$emit("updateIframeHeight");
        },
    },
};
</script>
